var SJ = SJ || {};
var __ = __ || function(str) {
        return str;
    };
var i18nLang = i18nLang || 'en';

//add date.now support to ie8
Date.now = Date.now || function() { return +new Date; };

SJ.Core = SJ.Core || {
    _staticUrl: null, //static url cache

    staticUrl: function (url) {
        if ( ! SJ.Core._staticUrl ) {
            var meta = $('meta[name="static_url"]');
            if ( meta.length ) {
                SJ.Core._staticUrl = meta
                    .attr('content')
                    .replace(SJ.Core.Regex.endSlash, '');
            } else {
                //Fallback
                return SJ.Core.url(url);
            }
        }

        url = url.replace(SJ.Core.Regex.beginSlash, '');

        return SJ.Core._staticUrl + '/' + url;
    },

    parseURL: function (url) {
        var parser = document.createElement('a');
        parser.href = url;
        return parser;
    },

    getCookie: function(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length,c.length);
            }
        }
        return "";
    },

    IsStorageAvailable: function(type) {
        try {
            var storage = window[type],
                x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        }
        catch(e) {
            return false;
        }
    },

    PaneVisible: function () {
        if ( typeof SJ.Pane !== 'undefined' ) {
            return SJ.Pane.visible();
        } else {
            return $('.pane').is(':visible');
        }
    },

    ScriptLoader: {
        callbackQueue: [],
        Load: function(libraries, callback) {
            var loaded = [],
                librariesHash = hash(libraries);

            function loadScript(src, index) {
                var urlParts = src.split('?'),
                    extension = urlParts[0].split('.').pop();

                if ( /^https?:\/\//i.test(src) === false ) {
                    src = SJ.Core.staticUrl(src);
                }

                if ( extension === 'css' ) {
                    //CSS files can't be loaded using getScript, so we add <link> to <head>
                    $('<link/>', {
                        rel: 'stylesheet',
                        type: 'text/css',
                        href: src
                    })
                        .on(
                            'load',
                            function () {
                                loaded[index] = true;
                                if ( libraryLoaded() ) {
                                    handleLibraryLoaded();
                                }
                            })
                        .appendTo('head');
                } else {
                    $.getScript(
                        src,
                        function () {
                            loaded[index] = true;
                            if ( libraryLoaded() ) {
                                handleLibraryLoaded();
                            }
                        }
                    );
                }
            }

            function libraryLoaded() {
                return loaded.indexOf(false) === -1;
            }

            function handleLibraryLoaded() {
                var callbackQueue = SJ.Core.ScriptLoader.callbackQueue[librariesHash];
                callbackQueue.loaded = true;

                //Running all callbacks
                for ( var i = 0; i < callbackQueue.callbacks.length; i++ ) {
                    callbackQueue.callbacks[i]();
                }
            }

            function hash(libraries) {
                if ( typeof libraries === 'object' ) {
                    libraries = libraries.join('.');
                }

                return libraries.hash();
            }

            function initializeLoader() {
                //If it's a first call, create new entry in callback queue
                if ( typeof SJ.Core.ScriptLoader.callbackQueue[librariesHash] === 'undefined' ) {
                    SJ.Core.ScriptLoader.callbackQueue[librariesHash] = {
                        loaded: false,
                        callbacks: []
                    };

                    addCallback();

                    if ( typeof libraries === 'string' ) {
                        libraries = [libraries];
                    }

                    //Start loading scripts
                    for ( var index = 0; index < libraries.length; index++ ) {
                        loadScript(libraries[index], index);
                    }
                } else {
                    addCallback();
                }

                function addCallback() {
                    if ( typeof callback === 'function' ) {
                        SJ.Core.ScriptLoader.callbackQueue[librariesHash].callbacks.push(callback);
                    }
                }
            }
            if (
                typeof SJ.Core.ScriptLoader.callbackQueue[librariesHash] !== 'undefined' &&
                SJ.Core.ScriptLoader.callbackQueue[librariesHash].loaded
            ) {
                //Library is already loaded, just calling callback
                callback();
            } else {
                //Load libraries
                initializeLoader();
            }
        }
    },

    Regex: {
        beginSlash: /^\//,
        endSlash: /\/$/,
        regexIso8601: /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(Z|([\-+])(\d{2}):?(\d{2}))?)?)?)?$/
    },

    Date: {
        getUTCDate: function(date) {
            //It's gonna fail on Safari so we have to do it manually
            if ( isNaN(Date.parse(date)) ) {
                var dateParts = SJ.Core.Regex.regexIso8601.exec(date),
                    lOff = -(new Date().getTimezoneOffset()),
                    lHrs = Math.floor(lOff / 60),
                    lMin = lOff % 60;
                if ( dateParts ) {
                    date = Date.UTC(
                        dateParts[1],
                        (dateParts[2] || 1) - 1,
                        dateParts[3] || 1,
                        dateParts[4] - (dateParts[7] ? dateParts[8] ? dateParts[8] + dateParts[9] : 0 : lHrs) || 0,
                        dateParts[5] - (dateParts[7] ? dateParts[8] ? dateParts[8] + dateParts[10] : 0 : lMin) || 0,
                        dateParts[6] || 0
                    );
                }
            }
            return new Date(date);
        }
    },

    user_id : null,

    url : function(url) {
        url = url || '/';
        if (!url.match(SJ.Core.Regex.beginSlash)) {
            url = '/'+url;
        }

        if (typeof $CURRENTAPP !== "undefined") {
            url = '/' + $CURRENTAPP + url;
        }

        return url
    },

    loadUserId : function() {
        SJ.Core.user_id = $('.sj-nav-user *[data-user-id]').data('user-id');
    },

    getURLParameter: function(name, href) {
        if (typeof href === 'undefined') {
            href = location.search;
        }

        return decodeURIComponent((new RegExp(name + '=([^&]*)', 'g').exec(href) || [, ''])[1]);
    },

    truncate_text : function(text, length) {
        length = (typeof length === 'undefined') ? 100 : parseInt(length, 10);
        var text_length = text.length;

        if(text_length < 3) {
            text_length = 3;
        }

        if(text_length > length ) {

            text = text.substr(0, (length - 3));
            text = text + '...';
        }

        return text;
    },

    /*
     Function to print message box
     content - message text
     opt - object parameters
     id - (if set)print message box in 'id' container or return html
     type - info, success, danger, warning - default info
     close - (0/1) show close btn (x)
     header - content header
     more - show btn with extra content in textarea
     */
    print_box: function(content, opt) {

        var options = {
            id: null,
            type: 'info',
            close: 0,
            header: '',
            more: ''
        };
        if (typeof opt !== 'undefined') {
            $.extend(options, opt);
        }

        if (typeof content !== 'undefined') {

            var print_box_id = 'print_box_' + (new Date().getTime());

            options.type = options.type.replace(/^\s+|\s+$/g, "").toLowerCase();

            if (options.type !== 'danger' && options.type !== 'success' && options.type !== 'info' && options.type !== 'warning') {
                options.type = 'info';
            }

            options.close = parseInt(options.close, 10);

            if (options.close) {
                options.close = '<button type="button" class="bs3-close" data-dismiss="alert" aria-hidden="true">&times;</button>';
            } else {
                options.close = '';
            }

            if (options.more.length > 0) {
                var more = options.more;
                options.more = '<div><span class="hide type_message"><small class="bs3-label bs3-label-default"><span>HTML</span>&nbsp; | &nbsp;<span>TXT</span></small></span><span class="btn right small ' + options.type + '">&hellip;</span><div class="clear"></div></div>';
                options.more += '<div class="more hide">';

                var closeTXT = '', closeHTML = 'hide';
                if (more.indexOf('<') !== -1) {
                    closeTXT = 'hide';
                    closeHTML = '';
                }
                options.more += '<textarea rows="4" cols="30" class="' + closeTXT + ' print_box_textarea" style="width:100%">' + more + '</textarea>';
                options.more += '<div class="' + closeHTML + ' print_box_html">' + more + '</div>';
                options.more += '</div>';
                $(document).on('click', '#' + print_box_id + '.bs3-alert div span.btn', function(e) {
                    $(this).parents('div.bs3-alert').find('div.more, span.type_message').toggle();
                    e.preventDefault();
                });
                $(document).on('click', '#' + print_box_id + '.bs3-alert div small.label', function(e) {
                    $(this).parents('div').find('.print_box_textarea, .print_box_html').toggle();
                    e.preventDefault();
                });
            }

            if (options.header.length > 0) {
                options.header = '<b>' + options.header + '</b>';
            }

            content = '<div id="' + print_box_id + '" class="bs3-alert bs3-alert-dismissable bs3-alert-' + options.type + '">' + options.close + options.header + '<p>' + content + '</p>' + options.more + '</div>';

            if (options.id !== null) {
                $(options.id).html(content);
            } else {
                return content;
            }

        }
    },
    // Load images in File manager - Outline gallery
    outline_gallery: function() {
        // Imagick fail when have to many picture to outline so we queue requests
        var delay = 0;

        $('#load_new_href ul li img').each(function() {
            var $img = $(this);

            setTimeout(function() {
                var new_href = $img.attr('new_href');
                $img.attr('src', new_href);
            }, delay);

            delay += 100;
        });
    },
    // Init popover
    popover: function() {
        // Lib Bootstrap

        $(document).on('mouseover', '._popover', function() {
            $(this).popover({
                title: "title",
                placement: "bottom",
                trigger: "hover",
                html: true
            });
        });
    },
    // Load images in File manager
    LoadImages: {
        init: function() {
            // Conteiner for filemanager and header logo image
            var conteiner = ( SJ.Core.PaneVisible() ) ? '.pane #sj-content, .pane #pane_scrollcontainer' : '#sj-content',
                $id;
            if ($('#lazyloading').length) {
                $id = $(conteiner);
            } else {
                $id = $(conteiner);
            }
            // Setting aditional spin for header logo profile picture and images in _image_preloader clas conteiner
            if($('#header-logo, .sj-nav-user, .profile_picture, ._image_preloader').length > 0){

                SJ.Core.LoadImages.load($('#header-logo, .sj-nav-user, .profile_picture, ._image_preloader, .element-resourceimage, .compact_inline_editor'));
            }

            if($id.length){
                SJ.Core.LoadImages.load($id);
                SJ.Core.LoadImagesLazy.init($id);
            }
        },
        load: function($id) {

            if ($id === SJ.Core.LoadImagesLazy.$window) {
                $id = $(document);
            }

            $id.find('img:not(.rendered, .lazy, .pending)').each(function() {
                var $img = $(this);
                $img.addClass('pending');
                $img.data('load_tries', 0);

                if ( typeof $img.attr('src') !== 'undefined' && $img.attr('src') !== false) {

                    if ($img.hasClass('bs3-hide')) {
                        $img.removeClass('bs3-hide').next('i').remove();
                    }

                    $img.addClass('bs3-hide').after('<i class="fa fa-refresh fa-spin fa-2x"></i>');
                    $img.next('i').attr('title', __('Converting'));

                    $img.on('load', function() {
                        $(this).addClass('rendered').removeClass('bs3-hide pending').next('i').remove();
                        // We are reseting image dimensions because without Width and Height setted we would have
                        // Troubles with Marquee animation (it would be displayed in strange way)
                        if (
                            $id.hasClass('element-text') === true ||
                            $id.hasClass('element-marquee') === true ||
                            $id.hasClass('element-accordion') === true ||
                            $id.hasClass('compact_inline_editor') === true
                        ) {
                            if ( (typeof $(this).attr('width') === 'undefined' || $(this).attr('width') == 0 )
                                || (typeof $(this).attr('height') === 'undefined' || $(this).attr('height') == 0) )  {
                                $(this).removeAttr('width');
                                $(this).removeAttr('height');
                                $(this).attr('width',$(this).width());
                                $(this).attr('height',$(this).height());
                            }
                        }
                    });

                    $img.on('error', function() {
                        var self = this;
                        var loadTries = $(self).data('load_tries');
                        $(self).data('load_tries', ++loadTries);
                        // Don't try for more than 5 minutes, the user probably won't be paying attention that long
                        if ( loadTries > 30 ) {
                            return;
                        }

                        setTimeout(function() {
                            if(self.complete == false || typeof self.complete === 'undefined' || self.naturalWidth === 0){
                                var src = $(self).attr('src').replace(/[?&]ref=[\d]+/g,'');
                                $(self).removeAttr('src');
                                $(self).attr('src', src + ( (src.indexOf('?') >= 0 ) ? '&' : '?') + 'ref=' +  ( new Date()).getTime() );
                            }
                        }, 10000);
                    });
                }
            });

            setTimeout(function() {
                SJ.Core.img_refresh($id);
            }, 500);

        }
    },

    img_refresh: function($id) {
        // Check if image already loaded (Opera issue)
        $id.find('img:not(.rendered, .lazy)').each(function() {
            if (typeof $(this).attr('src') !== 'undefined' && $(this).attr('src')) {
                if ((typeof this.complete === 'undefined' || this.complete) && this.naturalWidth !== 0) {
                    $(this).trigger("load");
                }
            }
        });
    },

    LoadImagesLazy: {
        $container: null,
        $window: $(window),
        threshold: 0,
        init: function($container, threshold) {
            var self = SJ.Core.LoadImagesLazy;

            if ($('img.lazy').length) {
                self.threshold = (typeof threshold !== 'undefined') ? parseInt(threshold, 10) : 200;
                self.$container = (typeof $container !== 'undefined' && $container.length > 0) ? $container : self.$window;


                $('img.lazy:not(.rendered)').each(function() {
                    $(this).one("appear", function() {
                        if (typeof $(this).attr('src') === 'undefined' || $(this).attr('src') === false) {
                            $(this).attr('src', $(this).data('original')).removeClass('lazy');
                            SJ.Core.LoadImages.load(self.$container);
                        }
                    });
                });

                self.$container.on('scroll resize', function() {
                    SJ.Core.LoadImagesLazy.update();
                });

                SJ.Core.LoadImagesLazy.update();
            }
        },
        update: function() {
            $('img.lazy:not(.rendered)').each(function() {
                if (!SJ.Core.LoadImagesLazy.belowthefold(this)) {
                    $(this).trigger('appear');
                }
            });
        },
        belowthefold: function(element) {
            var fold = 0,
                $container = SJ.Core.LoadImagesLazy.$container;

            if ($container === SJ.Core.LoadImagesLazy.$window) {
                fold = ($container.innerHeight() ? $container.innerHeight() : $container.height()) + $container.scrollTop();
            } else {
                fold = $container.offset().top + $container.height();
            }

            fold = fold + SJ.Core.LoadImagesLazy.threshold;

            return fold <= $(element).offset().top;
        }
    },
    KeywordsList: {
        init: function() {

            var pane = SJ.Core.PaneVisible() ? '.pane ' : '';
            var $keywords = $(pane + '#_keywords-list');

            if ($keywords.length > 0 && $keywords.data('semafor') != 1) {

                $keywords.data('semafor', 1);

                var self = SJ.Core.KeywordsList;

                // Bind events
                $(pane + '#_add-keywords-btn').on('click', function(e) {
                    e.preventDefault();
                    self.add();
                    self.update();
                });
                $(pane + '#_keywords-list').on('click', 'span._keyword.bs3-label a', function(e) {
                    e.preventDefault();
                    self.remove(this);
                    self.update();
                });
                // Enter on input should click add button
                $(pane + 'input[name="keywordslist"]').on('keypress', function(e) {
                    if (e.which === 13) {
                        $('#_add-keywords-btn').click();
                        return false;
                    }
                });
            }
        },
        add: function() {
            var keywordsNode = $('input[name="keywordslist"]'),
                keywords = keywordsNode.val(),
                parts = keywords.split(',');

            parts = $(parts).filter(function(el,val) {
                return $.trim(val).length !== 0;
            }); //filter out empty strings on jQuery object for IE8 compatibility

            if (parts.length) {
                $('._no-keywords-found').remove();
                $.each(parts, function(index, value) {
                    var val = $.trim(value);
                    if (!$('span._keyword[data-keyword="' + val + '"]').length) {
                        // It doesnt exist so add it
                        if (val.length > 0) {
                            $('#_keywords-list').append('<span class="_keyword bs3-label bs3-label-info" data-keyword="' + val + '">' + val + ' <a href="#"><i class="fa fa-times-circle fa-inverse"></i>&nbsp;</a></span> ');
                        }
                    }
                });
                keywordsNode.val('').focus();
            }
        },
        remove: function(element) {
            $(element).closest('span').remove();
        },
        update: function() {
            // Updates the hidden input
            var keywords = [],
                keywordsNode = $('span._keyword');
            if (keywordsNode.length) {
                keywordsNode.each(function() {
                    keywords.push($(this).data('keyword'));
                });
                var val = keywords.join(',');
                $('input[name="keywords"]').val(val);
            } else {
                // No keywords
                $('input[name="keywords"]').val('');
                if (!$('._no-keywords-found').length) {
                    $('#_keywords-list').append('<div class="_no-keywords-found"><div class="bs3-alert bs3-alert-warning bs3-alert-dismissable"><p>' + __('No keywords added.') + '</p></div></div>');
                }
            }
        }
    },
    SubjectsList: {
        init: function() {

            var pane = SJ.Core.PaneVisible() ? '.pane ' : '';
            var $subject_list = $(pane + '#_subjects-list');

            if ($subject_list.length > 0 && $subject_list.data('semafor') != 1) {

                $subject_list.data('semafor', 1);
                var self = SJ.Core.SubjectsList;

                // Bind events
                $(pane + '#_add-subject-btn').on('click', function(e) {
                    e.preventDefault();
                    self.add();
                    self.update();

                });
                $(pane + '#_subjects-list').on('click', 'span._subject.bs3-label a', function(e) {
                    e.preventDefault();
                    self.remove(this);
                    self.update();
                });
                // Enter on input should click add button
                $(pane + 'select[name="subjectslist"]').on('keypress', function(e) {
                    if (e.which === 13) {
                        $('#_add-subject-btn').click();
                        return false;
                    }
                });
            }
        },
        add: function() {
            var subject_id = $('select[name="subjectslist"]').val(),
                subjectOptionNode = $('select[name="subjectslist"] option[value="' + subject_id + '"]'),
                subject = subjectOptionNode.text();

            if (subject_id) {
                $('._no-subjects-found').remove();
                $('#_subjects-list').append('<span class="_subject bs3-label bs3-label-info" data-subject="' + subject_id + '">' + subject + ' <a href="#"><i class="fa fa-times-circle fa-inverse"></i></a></span> ');
                subjectOptionNode.remove();
            }
        },
        remove: function(element) {
            var $remove = $(element).closest('span'),
                subject_id = $remove.data('subject'),
                subject = $remove.text();

            $remove.remove();
            $('select[name="subjectslist"]').append($('<option>', {value: subject_id}).text(subject));
        },
        update: function() {
            // Updates the hidden input
            var subjects = [],
                subjectNodes = $('span._subject');
            if (subjectNodes.length) {
                subjectNodes.each(function() {
                    subjects.push($(this).data('subject'));
                });
                var val = subjects.join(',');
                $('input[name="subjects"]').val(val);
            } else {
                // No subjects
                $('input[name="subjects"]').val('');
                if (!$('._no-subjects-found').length) {
                    $('#_subjects-list').append('<div class="_no-subjects-found"><div class="bs3-alert bs3-alert-warning bs3-alert-dismissable"><p>' + __('No subjects added.') + '</p></div></div>');
                }
            }
        }
    },
    Datepicker: {
        fix_position: function(input, obj) {
            // Set high z-index
            setTimeout(function(){
                $('.ui-datepicker').each(function(n, e) {
                    $(e).css('z-index', '60000');
                    if ($(obj.input).parents('.pane').length) {
                        $(e).css('z-index', '600000');
                    }
                });
            }, 0);
        },
        init: function() {

            SJ.Core.Datepicker.date_filter();

            var date = new Date(),
                end_year = date.getFullYear(),
                start_year = end_year - 100;

            $('input.datepicker').datepicker({
                dateFormat: 'yy-mm-dd',
                beforeShow: SJ.Core.Datepicker.fix_position
            });

            $('input.datepicker-years').datepicker({
                dateFormat: 'yy-mm-dd',
                beforeShow: SJ.Core.Datepicker.fix_position,
                showOn: "button",
                buttonImage: "",
                buttonImageOnly: true,
                changeYear: true,
                changeMonth: true
            });

            $('input.datepicker-years-nofuture').datepicker({
                dateFormat: 'yy-mm-dd',
                beforeShow: SJ.Core.Datepicker.fix_position,
                showOn: "button",
                buttonImage: "",
                changeYear: true,
                changeMonth: true,
                yearRange: start_year + ':' + end_year
            });

            $('input.datepicker, input.datepicker-years, input.datepicker-years-nofuture')
                .after('<span class="fa fa-calendar add-on ui-datepicker-trigger" style="cursor:pointer"></span>');

            $(document).on('click', '.ui-datepicker-trigger', function() {
                $(this).parent().find('input.datepicker, input.datepicker-years, input.datepicker-years-nofuture').datepicker("show");
            });

            $('input.datepicker-noimage').datepicker({
                changeYear: true,
                changeMonth: true,
                dateFormat: 'yy-mm-dd',
                beforeShow: SJ.Core.Datepicker.fix_position
            });

            $('input.datepicker-noimage-years').datepicker({
                dateFormat: 'yy-mm-dd',
                beforeShow: SJ.Core.Datepicker.fix_position,
                changeYear: true,
                changeMonth: true,
                yearRange: start_year + ':' + (end_year+10)
            });

            $('input.datepicker-noimage-years-nofuture').datepicker({
                dateFormat: 'yy-mm-dd',
                beforeShow: SJ.Core.Datepicker.fix_position,
                changeYear: true,
                changeMonth: true,
                yearRange: start_year + ':' + end_year
            });

            $('input.datepicker-noimage-years-nofuture-position-standard').datepicker({
                dateFormat: 'yy-mm-dd',
                changeYear: true,
                changeMonth: true,
                yearRange: start_year + ':' + end_year
            });

            $('input.datepicker-noimage-start').datepicker({
                dateFormat: 'yy-mm-dd',
                changeYear: true,
                changeMonth: true,
                beforeShow: SJ.Core.Datepicker.fix_position,
                onClose: function(selectedDate) {
                    SJ.Core.Datepicker.set_end_by_start(selectedDate, '');
                }
            });

            $('input.datepicker-noimage-end').datepicker({
                dateFormat: 'yy-mm-dd',
                changeYear: true,
                changeMonth: true,
                beforeShow: SJ.Core.Datepicker.fix_position,
                onClose: function(selectedDate) {
                    SJ.Core.Datepicker.set_start_by_end(selectedDate, '');
                }
            });

            $('input.datepicker-noimage-start-tommorow').datepicker({
                dateFormat: 'yy-mm-dd',
                minDate: '+1d',
                beforeShow: SJ.Core.Datepicker.fix_position,
                onClose: function(selectedDate) {
                    SJ.Core.Datepicker.set_end_by_start(selectedDate, '-tommorow');
                }
            });

            $('input.datepicker-noimage-end-tommorow').datepicker({
                dateFormat: 'yy-mm-dd',
                minDate: '+1d',
                beforeShow: SJ.Core.Datepicker.fix_position,
                onClose: function(selectedDate) {
                    SJ.Core.Datepicker.set_start_by_end(selectedDate, '-tommorow');
                }
            });
        },
        set_end_by_start: function(selectedDate, selector) {

            var splited_date_start = selectedDate.split('-'), // We must split for IE8
                dateEndNode = $('input.datepicker-noimage-end' + selector),
                splited_date_end   = dateEndNode.val().split('-'),
                date_start = new Date(parseInt(splited_date_start[0],10), (parseInt(splited_date_start[1],10)-1), parseInt(splited_date_start[2],10)), // -1 for month
                date_end = new Date(parseInt(splited_date_end[0],10), (parseInt(splited_date_end[1],10)-1), parseInt(splited_date_end[2],10));

            $('input.datepicker-noimage-end').datepicker("option", "minDate", date_start);

            if (date_start.getTime() > date_end.getTime()) {
                dateEndNode.val($('input.datepicker-noimage-start' + selector).val());
            }
        },
        set_start_by_end: function(selectedDate, selector) {

            var dateStartNode = $('input.datepicker-noimage-start' + selector),
                splited_date_start = dateStartNode.val().split('-'),
                splited_date_end   = selectedDate.split('-'), // We must split for IE8
                date_start = new Date(parseInt(splited_date_start[0],10), (parseInt(splited_date_start[1],10)-1), parseInt(splited_date_start[2],10)), // -1 for month
                date_end = new Date(parseInt(splited_date_end[0],10), (parseInt(splited_date_end[1],10)-1), parseInt(splited_date_end[2],10));


            $('input.datepicker-noimage-start').datepicker("option", "maxDate", date_end);

            if (date_end.getTime() < date_start.getTime()) {
                dateStartNode.val($('input.datepicker-noimage-end' + selector).val());
            }
        },
        date_filter: function() {

            $('.pane input[name=period_type]').click(function() {
                if ($(this).val() == 2) {
                    $("select[name=date_period]").removeAttr('disabled');
                    $("input[name=date_start], input[name=date_end]").attr('disabled', 'disabled');
                } else {
                    $("select[name=date_period]").attr('disabled', 'disabled');
                    $("input[name=date_start], input[name=date_end]").removeAttr('disabled');
                }
            });
        }
    },
    TimePicker: {
        init: function () {
            var initializer = function () {
                var node = $('input.timepicker');
                node.timepicker({
                    'scrollDefault': 'now',
                    'disableTextInput': true,
                    'appendTo': node.closest('div'),
                    'useSelect': true,
                    'className': 'bs3-form-control'
                });
            };

            SJ.Core.ScriptLoader.Load(
                [
                    'vendor/jonthornton/jquery-timepicker/jquery.timepicker.min.js',
                    'vendor/jonthornton/jquery-timepicker/jquery.timepicker.min.css'
                ],
                function () {
                    if (typeof $.fn.timepicker !== 'undefined' ) {
                        initializer();
                    } else {
                        //The lib didn't finish initializing, let's give it a moment
                        setTimeout(initializer, 50);
                    }
                }
            );
        }
    },
    Validation: {
        init: function() {
            if (typeof $.validator !== 'undefined') {
                $.validator.addMethod("required", function(value, element, param) {
                    // check if dependency is met
                    if (!this.depend(param, element)) {
                        return "dependency-mismatch";
                    }
                    if (element.nodeName.toLowerCase() === "select") {
                        // could be an array for select-multiple or a string, both are fine this way
                        var val = $(element).val();
                        return val && val.length > 0;
                    }
                    if (this.checkable(element)) {
                        return this.getLength(value, element) > 0;
                    }
                    // Hook for Webkit Number inputs
                    if ($(element).attr('type') === 'number') {
                        if (
                            typeof element.validity !== 'undefined' &&
                            typeof param !== 'undefined' &&
                            typeof element.validity.valueMissing !== 'undefined' &&
                            typeof element.validity.badInput !== 'undefined')
                        {
                            if (element.validity.badInput === true) {
                                return true;
                            } else {
                                return ! (element.validity.valueMissing === true);
                            }
                        }
                    }
                    return $.trim(value).length > 0;
                }, null);

                $.validator.addMethod("number", function(value, element) {
                    //Hook for Webkit Number inputs
                    if (typeof element.validity !== 'undefined' && typeof element.validity.badInput !== 'undefined') {
                        var val = element.validity.badInput;

                        if (val) {
                            return false;
                        }
                    }
                    return this.optional(element) || /^-?(?:\d+|\d{1,3}(?:[\s\.,]\d{3})+)(?:[\.,]\d+)?$/.test(value);
                }, null);

                $.validator.addMethod("phone", function(value, element) {
                    return this.optional(element) || /^[\d+]{6,18}$/.test(value);
                }, null);

                $.extend($.validator.messages, {
                    required: __("must not be empty. Please try again."),
                    email: __("must be an email address. Please try again."),
                    url: __("must contain URL. Please try again."),
                    number: __("must be numeric. Please try again."),
                    phone: __("must be a phone number without spaces. Please try again.")
                });

                /*
                 *  Function to resolve name input/select/textarea from list with errors
                 **/
                var formErrorList = $("._form-error-list");
                if (formErrorList.val()) {

                    var _form_error_list = $.parseJSON(formErrorList.val()),
                        $form_with_errors = $('form#' + _form_error_list.form_id);

                    formErrorList.parents('p').first().html('<b>' + $form_with_errors.find('h3').html() + '</b><br>' + formErrorList.parents('p').first().html());

                    $.each(_form_error_list.list_errors, function(index, value) {

                        var $field = $form_with_errors.find("[name='" + value + "']").first().addClass("bs3-has-error");

                        if (!$field.parents("div.bs3-form-group").first().hasClass("bs3-has-error")) {
                            $field.parents("div.bs3-form-group").first().addClass("bs3-has-error");
                        }
                    });
                }
            }
        },
        init_form: function(id) {
            if (typeof $.validator !== 'undefined') {

                $(id).each(function() {
                    $(this).validate({
                        onfocusout: false,
                        onkeyup: false,
                        success: function(label, element) {
                            var $error_div = $(element).parents('.bs3-form-group').first();
                            $error_div.removeClass('bs3-has-error');
                            $error_div.find('p.bs3-help-block').remove();
                        },
                        errorPlacement: function(error, element) {
                            var $error_div = $(element).parents('.bs3-form-group').first();
                            $error_div.addClass('bs3-has-error');

                            if (!$error_div.find('p.bs3-help-block').length && (error.length > 0) && (typeof error[0].innerHTML !== 'undefined') && (error[0].innerHTML.length > 0)) {

                                var name = __('Field'),
                                    err_info = '<p class="bs3-help-block bs3-text-danger">' + name + ' ' + error[0].innerHTML + '</p>';
                                // $(document).find('.bs3-has-error .bs3-text-danger').hide();
                                if ($(element).parent().find('*').length > 1) {
                                    $(element).parent().parent().append(err_info);
                                } else {
                                    $(element).parent().append(err_info);
                                }

                            }

                        },
                        invalidHandler: function(event, validator) {
                            var errors = validator.numberOfInvalids(),
                                $form = $(event.target),
                                $valid_form = $form.closest('._validation-form'),
                                message = '';

                            if (errors) {
                                $(document).find('.bs3-has-error').removeClass('bs3-has-error').find('.bs3-help-block').remove();
                                $(document).find('._validation-form .bs3-alert-danger').remove();


                                var form_header = '';
                                if ($valid_form.find('h3').length) {
                                    form_header = ': <b>' + $valid_form.find('h3').html() + '</b>';
                                }

                                var fieds = validator.invalidElements(),
                                    err_message = __('There was a problem processing the form') + form_header + '<br>';

                                for (var i = 0; i < errors; i++) {
                                    var $label = ($form.find("label[for='" + fieds[i].name + "']").length) ? $form.find("label[for='" + fieds[i].name + "']") : $(fieds[i]).parents('.bs3-form-group').find('label').first(),
                                        field_name = $label.text();

                                    if (field_name === __('Please enter the letters above')) {
                                        field_name = __('Captcha');
                                    }

                                    err_message += '<b>' + field_name + '</b> - ' + validator.errorMap[fieds[i].name] + '<br>';
                                    $label.parent().addClass('bs3-has-error');
                                }

                                message = SJ.Core.print_box(err_message, {type: 'danger', close: 1});
                                $($form).prepend(message);
                            }
                        },
                        submitHandler: function(form) {

                            // Disable button to prevent multible submits
                            const submitButton = $(form).find('[type="submit"]');
                            submitButton.prop('disabled', true);

                            if ($(form).parents('.ajax-container').length) {
                                $(form).removeClass('_validation-form').find('[type="submit"]').trigger('click');
                            } else {

                                if($(form).attr('_already_sent') === 'true'){
                                    return false;
                                }

                                $(form).attr('_already_sent', 'true');

                                if ( SJ.SitesCaptcha !== undefined ) {
                                    SJ.SitesCaptcha.submitHandler(form);
                                } else {
                                    // Use the native submit method of the form element
                                    form.submit();
                                }
                            }
                        }
                    });
                });

            }
        },
        check_form: function(id) {
            var valid = true;
            $(id).find('[required], [type="url"], [maxlength], [minlength]').each(function() {
                var node = $(this);
                if (node.attr('placeholder') === node.val()) {
                    node.val('');
                }

                if (node.hasClass('compact_editor')) {
                    if (typeof tinymce.activeEditor !== 'undefined' && tinymce.activeEditor !== null) {
                        // Fix save when container is empty - fix IE8,9
                        if( ! node.val().length) {
                            node.val('&nbsp;');
                        }
                        tinymce.activeEditor.save();
                    }
                }

                var test = node.valid();
                if (test === false) {
                    valid = false;
                }
            });
            return valid;
        }
    },
    CompactEditor: {
        bind_count: 0,
        staticUrl: null,
        ver: '4.6.3j',
        fix_scrolling: function(container) {
            var lastScrollTop = 0,
                container_scroll = '.pane #sj-content, .pane .page-body';

            if(typeof container !== 'undefined') {
                container_scroll = container;
            }

            $(container_scroll).scroll(function() {
                var st = $(this).scrollTop(),
                    is_pane = typeof container_scroll !== 'object',
                    $contentToScroll = $('.mce-menu:visible, .mce-popover:visible');

                if(is_pane || $('#tinyMCE_editor').is(':visible')) {
                    var t = parseInt($contentToScroll.css('top'),10);

                    $('.mce-tooltip').hide();

                    if (st > lastScrollTop){
                        // Downscroll code
                        if($contentToScroll.length) {
                            if(is_pane) {
                                t = t - (st - lastScrollTop);
                            } else {
                                t = t + (st - lastScrollTop);
                            }
                        }
                    } else {
                        // Upscroll code
                        if($contentToScroll.length) {
                            if(is_pane) {
                                t = t + (lastScrollTop - st);
                            } else {
                                t = t - (lastScrollTop - st);
                            }
                        }
                    }

                    $contentToScroll.css('top', t  + 'px');
                }
                lastScrollTop = st;
            });
        },
        /* If you want use CompactEditor you must add class="compact_editor" to textarea */
        init: function(inline) {

            if ( this.staticUrl === null ) {
                this.staticUrl = SJ.Core.staticUrl("/vendor/tinymce_dev/plugins/");
            }

            if ( typeof inline === 'undefined' ) {
                inline = false;
            }
            // load TinyMCE crossdomain
            // http://www.tinymce.com/wiki.php/How-to_load_TinyMCE_crossdomain
            // if(document.location.host.match(/\.(sites|messages|resources|forum)\./i)) {
            //     document.domain = document.location.host.replace(/^.*\.(sites|messages|resources|forum)\./i, '');
            // }

            var in_pane = '';

            if( SJ.Core.PaneVisible() ) {
                in_pane = ".pane ";
            }

            var selector = in_pane + '.compact' + this.tinymceInlineClassName(inline) + '_editor';

            if ($(selector).length > 0) {
                if (typeof tinymce === 'undefined') {
                    $.getScript(
                        SJ.Core.staticUrl("vendor/tinymce_dev/tinymce.gzip.js"),
                        function () {
                            SJ.Core.CompactEditor.tinymceInitialize(selector, inline, in_pane);
                        }
                    );
                } else {
                    SJ.Core.CompactEditor.tinymceInitialize(selector, inline, in_pane);
                }
            }
        },

        reInit: function (inline) {
            if ( typeof inline === 'undefined' ) {
                inline = false;
            }
            // load TinyMCE crossdomain
            // http://www.tinymce.com/wiki.php/How-to_load_TinyMCE_crossdomain
            // if(document.location.host.match(/\.(sites|messages|resources|forum)\./i)) {
            //     document.domain = document.location.host.replace(/^.*\.(sites|messages|resources|forum)\./i, '');
            // }

            var in_pane = '';

            if( SJ.Core.PaneVisible() ) {
                in_pane = ".pane ";
            }

            var selector = in_pane + '.compact' + this.tinymceInlineClassName(inline) + '_editor';

            if ($(selector).length > 0) {
                tinymce.remove(selector);

                SJ.Core.CompactEditor.tinymceInitialize(selector, inline, in_pane);
            }
        },

        tinymceInitialize: function(selector, inline, in_pane) {
            var self = SJ.Core.CompactEditor,
                inline_class_name = self.tinymceInlineClassName(inline);

            if($('.mce-window').is(':visible')) {
                return;
            }

            if( in_pane.length > 0 ) {
                self.fix_scrolling();
            } else if ( $('#sj-content').length ) {
                self.fix_scrolling('#sj-content');
            }

            if (typeof tinymce.activeEditor !== 'undefined' && tinymce.activeEditor !== null) {
                $(selector).each(function() {
                    // Fix save when container is empty - fix IE8,9
                    if( ! $(this).val().length) {
                        $(this).val('&nbsp;');
                    }
                });

                tinymce.activeEditor.save();
            }

            var ex_plugins = '',
                plugins = {
                    "lists": self.staticUrl + "lists/plugin.js?v=" + self.ver,
                    "advlist": self.staticUrl + "advlist/plugin.js?v=" + self.ver,
                    "textcolor": self.staticUrl + "textcolor/plugin.js?v=" + self.ver,
                    "paste": self.staticUrl + "paste/plugin.js?v=" + self.ver,
                    "colorpicker": self.staticUrl + "colorpicker/plugin.js?v=" + self.ver,
                    "textpattern": self.staticUrl + "textpattern/plugin.js?v=" + self.ver,
                    "sj2_autolink": self.staticUrl + "sj2_autolink/plugin.js?v=" + self.ver
                };

            if($(selector).hasClass('compact' + inline_class_name + '_editor_images')) {
                plugins['sj2_image'] = self.staticUrl + "sj2_image/plugin.js?v=" + self.ver;
                ex_plugins += ' | sj2_image ';
            }

            if($(selector).hasClass('compact' + inline_class_name + '_editor_links')) {
                plugins['sj2_link'] = self.staticUrl + "sj2_link/plugin.js?v=" + self.ver;
                ex_plugins += ' | sj2_link sj2_unlink ';
            }

            if(in_pane.length <= 0) {
                if($(selector).hasClass('compact' + inline_class_name + '_editor_tables')) {
                    plugins['sj2_table'] = self.staticUrl + "sj2_table/plugin.js?v=" + self.ver;
                    ex_plugins += ' | sj2_table ';
                }

                if($(selector).hasClass('compact' + inline_class_name + '_editor_code')) {
                    plugins['sj2_code'] = self.staticUrl + "sj2_code/plugin.js?v=" + self.ver;
                    ex_plugins += ' | sj2_code ';
                }
            }

            var height = "auto";

            if($(selector).hasClass('compact' + inline_class_name + '_editor_tall')) {
                height = "300px";
            }

            tinymce.init({
                selector: selector,
                height: height,
                language: (i18nLang === 'en-gb' || i18nLang === 'en-us' || i18nLang === 'xx-xx') ? 'en' : i18nLang,
                inline: inline,
                fixed_toolbar_container: '',
                menubar: false,
                statusbar: false,
                relative_urls: false,
                schema: "html5",
                browser_spellcheck: true,
                theme: "sj2",
                skin: "sj2",
                image_advtab: true,
                typeahead_urls: false,
                toolbar_items_size: 'small',
                invalid_elements: "script",
                valid_elements : "*[*]",
                content_css: SJ.Core.staticUrl("/css/default.css?v=" + self.ver),
                preview_styles: 'font-family font-size font-weight font-style text-decoration text-transform border border-radius outline text-shadow',
                external_plugins: plugins,
                file_browser_callback: function(field_name, url, type, win) {
                    // Required empty callback to show browse button
                },
                setup: function(ed) {
                    var paneNode = $('.pane');
                    ed.on('change', function() {
                        ed.save();

                        //SJ.Core.LoadImages.load($(selector));
                        $(selector).siblings('textarea').text(ed.getContent());
                    });

                    if ( SJ.Core.PaneVisible() ) {
                        paneNode.on('close', function () {
                            ed.destroy();
                        });
                        paneNode.on('back', function () {
                            ed.destroy();
                        });
                        paneNode.find('form').on('submit');
                    }
                },
                style_formats: [
                    {
                        title: 'Headers', items: [
                            {title: 'Header 1', format: 'h1'},
                            {title: 'Header 2', format: 'h2'},
                            {title: 'Header 3', format: 'h3'},
                            {title: 'Header 4', format: 'h4'},
                            {title: 'Header 5', format: 'h5'},
                            {title: 'Header 6', format: 'h6'}
                        ]
                    },
                    {
                        title: 'Inline', items: [
                            {title: 'Strikethrough', icon: 'strikethrough', format: 'strikethrough'},
                            {title: 'Superscript', icon: 'superscript', format: 'superscript'},
                            {title: 'Subscript', icon: 'subscript', format: 'subscript'},
                            {title: 'Code', icon: 'code', format: 'code'}
                        ]
                    },
                    {
                        title: 'Blocks', items: [
                            {title: 'Paragraph', format: 'p'},
                            {title: 'Blockquote', format: 'blockquote'},
                            {title: 'Pre', format: 'pre'}
                        ]
                    }
                ],
                toolbar: "undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | styleselect fontselect fontsizeselect forecolor backcolor removeformat" + ex_plugins
            });
        },

        tinymceInlineClassName: function (inline) {
            return inline ? '_inline' : '';
        },

        remove: function($container, inline) {
            if ( typeof inline === 'undefined' ) {
                inline = false;
            }

            var $editor = $container.find('.compact' + (inline ? '_inline' : '') + '_editor');
            if ($editor.length > 0) {

                if (typeof tinymce.activeEditor !== 'undefined' && tinymce.activeEditor !== null) {
                    // Fix save when container is empty - fix IE8,9
                    if( ! $editor.val().length) {
                        $editor.val('&nbsp;');
                    }

                    tinymce.activeEditor.save();
                    tinymce.activeEditor.remove();
                }
            }
        }
    },
    Form: {
        init: function() {
            $('._sj_multiple_save_prevent').each(function() {
                var form = $(this);
                form.find("[type='submit']").each(function() {
                    var button = $(this);
                    button.click(function(e) {
                        e.preventDefault();
                        form.append($('<input />', {
                            'type': 'hidden',
                            'name': button.attr('name'),
                            'value': button.val()
                        }));
                        form.submit();
                        form.find("[type='submit']").each(function(){
                            $(this).button('loading');
                        });
                    });
                });
            });
        }
    },
    ShareView: {
        init: function() {
            var shareTable = $('#share-table');
            if (shareTable.length) {
                // Share add
                $(document).on('updated', 'input[name="userrule"]', function() {
                    var userrule_id = $('input[name=userrule]').val(),
                        summary = $('input[name=nice_userrule]').val(),
                        html = '';

                    // Add the row
                    html += '<tr>';
                    html += '<td>';
                    html += '<input type="checkbox" class="userrule_id" name="userrule_ids[]" value="' + userrule_id + '">';
                    html += '</td>';
                    html += '<td>' + summary + '</td>';
                    html += '<td>';
                    html += '<select class="bs3-form-control" name="edit[' + userrule_id + ']">';
                    html += '<option value="0" selected="selected">' + __('View Only') + '</option>';
                    html += '<option value="1">' + __('Edit and View') + '</option>';
                    html += '</select>';
                    html += '<input type="hidden" name="userrules[]" value="' + userrule_id + '">';
                    html += '</td>';
                    html += '</td>';
                    html += '</tr>';

                    shareTable.find('tr:last').after(html);

                    // If there is a no user message then hide
                    shareTable.find('#no-user-message').addClass('hide');

                });

                // Share del
                $(document).on('click', '#unshare', function() {
                    shareTable.find('input:checked').not('.select_all').parents('tr').remove();

                    if (shareTable.find('tbody tr').length === 1) {
                        shareTable.find('#no-user-message').removeClass('hide');
                    }
                });
            }
        }
    },
    Browsers: {
        isIe: function() {
            return Boolean( $.browser.msie );
        },
        isVersionAtLeast: function(expected_version){
            var actual_version = parseInt($.browser.version);
            return (actual_version >= expected_version);
        }
    },

    // Filters are dedicated to hide or show filter div after the page is loaded
    Filters : {

        // Function to toggle filter etc..
        init: function()
        {
            var pane_selector = SJ.Core.PaneVisible() ? '.pane ' : '',
                $filter_container = $(pane_selector + '*[data-toggle-div]');

            if( $filter_container.length ) {
                // Show or hide filters event
                $filter_container.click(function(event) {
                    var selector = $(this).data('toggle-div');

                    if (!$(selector).is(':visible')) {
                        $filter_container.addClass('filter-selected');
                    }

                    $(selector).slideToggle("slow", function() {
                        if (!$(selector).is(':visible')) {
                            $filter_container.removeClass('filter-selected');
                        }

                        if(! $(selector).hasClass('show-filter')) {
                            if( pane_selector.length ) {
                                url = SJ.Core.Filters.get_clear_pane_url();
                            } else {
                                url = SJ.Core.Filters.get_clear_web_url();
                            }

                            localStorage.setItem(SJ.Core.user_id + '_' + url, $(selector).is(':hidden'));
                        }
                    });

                    event.preventDefault();
                });

                // Check status filter container - show or hide
                var url = null,
                    toggle = true,
                    toggle_stored_value = null,
                    selector = $filter_container.data('toggle-div');

                if($(selector).hasClass('show-filter')) {
                    $(selector).show();
                    $filter_container.addClass('filter-selected');
                } else {
                    // Get url to check toggle
                    if( pane_selector.length ) {
                        url = SJ.Core.Filters.get_clear_pane_url();
                    } else {
                        url = SJ.Core.Filters.get_clear_web_url();
                    }

                    // Try to take stored value for toggle for specified url
                    toggle_stored_value = localStorage.getItem( SJ.Core.user_id + '_' + url);

                    if( toggle_stored_value !== null ) {
                        toggle = toggle_stored_value;
                    }

                    toggle = toggle + ""; // Convert to string

                    if(toggle === "false") {
                        $(selector).show();
                        $filter_container.addClass('filter-selected');
                    } else {
                        $(selector).hide();
                    }
                }

            }
        },

        // Function preparing url
        get_clear_web_url: function() {
            var hostname = location.hostname,
                pathname = location.pathname;

            if( pathname !== '/' ) {
                hostname += pathname.replace(/\/[0-9]+$/g, '');
            }

            return hostname;
        },

        get_clear_pane_url: function() {
            var clear_url = SJ.Pane.invoked_url.indexOf("?"),
                url = SJ.Pane.invoked_url;

            if(clear_url >= 0) {
                url = url.slice(0,clear_url);
            }

            url = url.replace(/\/[0-9]+$/g, '');

            return url;
        }
    },
    Toggle : {
        init: function()
        {
            $('*[data-toggle-element]').each(function() {
                var node = $(this);
                node.click(function() {
                    var selector = node.data('toggle-element');
                    $(selector).slideToggle();
                });
                node.addClass('sj-cursor-pointer');
            })
        },
        'switch': function (selector, callback) {
            selector.click(function() {
                var node = $(this),
                    oldClass,
                    newClass,
                    newValue;

                switch (true) {
                    case node.hasClass('fa-check'):
                        oldClass = 'fa-check';
                        newClass = 'fa-ban';
                        newValue = false;
                        break;
                    case node.hasClass('fa-ban'):
                        oldClass = 'fa-ban';
                        newClass = 'fa-check';
                        newValue = true;
                        break;
                    default:
                        return false;
                }
                node.removeClass(oldClass);
                node.addClass(newClass);
                callback(this, newValue);
            });
        }
    },
    Rating : {
        init: function() {
            var ratingNode = $('.rating');
            if (ratingNode.length) {
                var url = "/resourcemanager/rate";
                if (ratingNode.hasClass('learning')) {
                    url = "/sites/rate";
                }

                $('[class^="_rating-star-"]').click(function() {
                    var id = $(this).data('id'),
                        rate = $(this).attr('class').slice(-1),
                        $self = $(this);

                    $.ajax({
                        url: url,
                        type: "POST",
                        data: {id: id, rate: rate}
                    }).done(function(data){
                        data = JSON.parse(data);
                        if (data.status) {
                            $self.parent().parent().html(data.data);
                        } else {
                            $self.parent()
                                .data('trigger', 'manual')
                                .data('placement', 'bottom')
                                .attr('title', data.data)
                                .tooltip('show');
                            setTimeout(function(){ $self.parent().tooltip('hide') }, 2000);
                        }
                    });
                });
            }
        }
    },

    Popover : {
        init: function() {
            try{
                $('.sj-popover').popover();
            }catch(err){
                // Nothing - probably bootstrap.js not loaded
            }
        }
    },

    InputList : {
        init: function() {
            var inputList = $('.sj-inputlist');
            inputList.on('click', 'a', function(e) {
                e.preventDefault();
                var $inputPrototype = $('.sj-inputlist-prototype').find('div').first();

                var $cloned = $inputPrototype.clone();
                $cloned.find('label').text('');
                $cloned.removeClass('bs3-hide');
                $cloned.addClass('sj-inputlist-cloned');
                $cloned.appendTo('.sj-inputlist-container');
            });

            inputList.on('click', '.sj-inputlist-remove', function() {
                var $node = $(this).parents('.sj-inputlist-cloned');
                $node.remove();
            });
        }
    },

    Colorpicker : {
        init : function() {

            if(typeof $().colorpicker !== 'undefined') {
                $('.sj-colorpicker').each(function() {
                    var format = 'hex';

                    if($(this).find('.sj-colorpicker-hsl').length) {
                        format = 'hsl';
                    }

                    if($(this).find('.sj-colorpicker-hsla').length) {
                        format = 'hsla';
                    }

                    if($(this).find('.sj-colorpicker-rgb').length) {
                        format = 'rgb';
                    }

                    if($(this).find('.sj-colorpicker-rgba').length) {
                        format = 'rgba';
                    }

                    $(this).colorpicker({
                        format:   format,
                        component: '.bs3-add-on, .bs3-input-group-addon',
                        template: '<div class="colorpicker bs3-dropdown-menu">' +
                        '<div class="colorpicker-saturation"><i><b></b></i></div>' +
                        '<div class="colorpicker-hue"><i></i></div>' +
                        '<div class="colorpicker-alpha"><i></i></div>' +
                        '<div class="colorpicker-color"><div /></div>' +
                        '</div>'
                    });
                });
            }
        }
    },

    Selectpicker : {
        init : function() {
            // New select
            if(typeof $().selectpicker !== 'undefined') {
                $('.sj-selectpicker').selectpicker();
            }
        }
    },

    Image : {
        init : function() {
            $('.pane-multiple-2').on('click', 'a.rotate-image', function(event) {
                event.preventDefault();
                var dir = ($(this).hasClass('cw')) ? '90' : '270';
                if (typeof $(this) !== 'undefined') {
                    SJ.Core.Image.rotate($(this).attr('id'), this, dir);
                }
            });
        },

        rotate : function(id, cont, dir) {

            id = id.replace( /\D+/g, '');
            $.ajax({
                url: "/rotate/" + id + "/" + dir,
                context: document.body,
                beforeSend: function(){
                    $('[id^="rotate-' + id + '"]').hide();
                },
                success: function(json) {
                    var data = JSON.parse(json),
                        newId = data.file.id,
                        href = data.href;

                    $(cont).parents('tr').find('a').each(function(){
                        $(this).attr('href', SJ.Core.Image.replaceId($(this).attr('href'), id, newId));
                    });

                    $(cont).parents('.pane-multiple').find('a.select').each(function(){
                        $(this).attr('href', SJ.Core.Image.replaceId($(this).attr('href'), id, newId));
                    });

                    var chooseButton = $('.pane-footer').find('[href*="choose"]');
                    chooseButton.attr('href', SJ.Core.Image.replaceId(chooseButton.attr('href'), id, newId));

                    $(cont).siblings('img').attr('src', href);

                    $('[id^="rotate-' + id + '-cw"]').attr('id', 'rotate-' + newId + '-cw');
                    $('[id^="rotate-' + id + '-ccw"]').attr('id', 'rotate-' + newId + '-ccw');
                }
            }).always(function(){
                $('[id^="rotate-"]').show();
            });
        },

        replaceId : function(href, id, newId) {
            if (typeof href !== 'undefined') {
                var newFiles        = [],
                    lastIndexLeft   = href.lastIndexOf("selected="),
                    lastIndexRight  = href.lastIndexOf("&");
                if (lastIndexLeft < lastIndexRight) {
                    files = href.substring(lastIndexLeft + 9, lastIndexRight);
                } else {
                    files = href.substring(lastIndexLeft + 9, href.length);
                }
                files = files.split('%2C');
                files.forEach(function(index) {
                    if (parseInt(index) === parseInt(id)) {
                        newFiles.push(newId);
                    } else {
                        newFiles.push(index);
                    }
                });
                href = href.replace( /selected=[^d]+/g, 'selected=' + newFiles.join('%2C'));
                return href;
            }
        }
    },
    SessionManager : {
        timer : 0,
        modal : null,
        counter : {},

        SessionExpiration : {
            tokenTimestamp : 0, //miliseconds since 1970
            timeToDecide : 100000, //default time before session ends in miliseconds
            difference : 0,

            set : function(seconds) {
                var oldValue = this.tokenTimestamp;
                var newValue = parseInt(seconds * 1000);
                this.difference = newValue - oldValue;

                if (oldValue != newValue) {
                    this.tokenTimestamp = newValue;
                    return true;
                } else {
                    return false;
                }
            },
            warningWindowTimeLeft : function() {
                return Math.floor(this.tokenTimestamp - (Date.now() + this.timeToDecide)); // n miliseconds before session ends
            },
            sessionTimeLeft : function() {
                return this.tokenTimestamp - Date.now();
            }
        },

        init : function() {
            var that = this;
            this.updateSessionExpiry();

            $(document).on('click', '#refresh_session', function(event) {
                event.preventDefault();
                that.refreshSession();
            });
            $(document).on('sjmodalclosed', '', function() {
                that.counter.stop();
            });
        },
        getSessionTimeout : function(callback) {
            $.ajax({
                url: SJ.Core.url("/app/sessionrefresh/get_session_timeout"),
                type: "POST"
            }).done(function(data) {
                callback(JSON.parse(data));
            });
        },
        updateSessionExpiry : function() {
            var that = this;
            this.getSessionTimeout(function(data) {
                if (data.status) {
                    that.SessionExpiration.set(data.session_expiry);
                } else {
                    that.SessionExpiration.set(0);
                }
                that.startTimer();
            });
        },
        startTimer : function() {
            clearTimeout(this.timer);
            var warningTime = this.SessionExpiration.warningWindowTimeLeft();
            if (warningTime > 0) {
                this.timer = setTimeout("SJ.Core.SessionManager.onTimeoutPassed();", warningTime);
            }
        },
        onTimeoutPassed : function() {
            var that = this;
            this.getSessionTimeout(function(data) {
                //if timer ends and session will be active longer that your "time to decide", then dont show warning window and start timer again
                if (that.SessionExpiration.set(data.session_expiry) && that.SessionExpiration.difference > that.SessionExpiration.timeToDecide) {
                    that.startTimer();
                } else {
                    that.showLogoutWindow();
                }
            });
        },
        showLogoutWindow : function() {
            return;  // Disabled because this feature is not reliable yet

            if ( ! SJ.Modal ) {
                return;
            }

            var _sec = this.SessionExpiration.timeToDecide/1000;
            var tmpMsg = '<div>' + __('Time left:') + '<p id="session_expired_counter_down">' + _sec + '</p> </div>';
            var message = SJ.Core.print_box(tmpMsg, {type: 'warning', header: __('Session will expire soon')});

            this.modal = SJ.Modal.init({closeButton : false});
            this.modal.title(__('Warning'));
            this.modal.addClass('sj-od-modal-logout-timeout');
            this.modal.appendContent(message);
            var link = '<a id="refresh_session" href="#" class="bs3-btn bs3-btn-primary sj-od-btn-renew-session" target="_blank">' + __('Refresh Session') + '</a>&nbsp;';
            this.modal.appendContent(link);
            this.modal.appendContent('<a href="' + $('a[href$="logout"]').attr('href') + '" class="bs3-btn bs3-btn-default sj-modal-close-btn">' + __('Logout') + '</a>');
            this.modal.show();

            this.counter = new Countdown({
                seconds: _sec,  // number of seconds to count down
                onUpdateStatus: function(sec){ $('#session_expired_counter_down').html(sec) } ,
                onCounterEnd : function() { $('a[href$="logout"]')[0].click() } // callback for each second
            });
            this.counter.start();
        },
        refreshSession : function() {
            var that = this;
            $.ajax({
                url: SJ.Core.url('/app/sessionrefresh/refresh_session'),
                type: "POST"
            }).done(function() {
                that.modal.remove();
                that.counter.stop();
                that.updateSessionExpiry();
            });
        }
    },

    SafetyButton: {
        image: null,
        init: function() {
            var self = this;
            $("#sj-global-safetybutton").bind("click", function(e) {
                // Prevent default Pane event
                e.stopPropagation();
                self.printScreen();
            });
        },
        printScreen: function() {
            var self = this,
                callback = function () {
                html2canvas(document.body)
                    .then(function (canvas) {
                        self.image = canvas.toDataURL("image/png");

                        // Execute Pane
                        SJ.Pane.init($("#sj-global-safetybutton a").data('panehref'));
                    });
            };

            //Loading script if needed
            if ( typeof html2canvas === 'undefined' ) {
                $.getScript("/ui/js/html2canvas.js", callback);
            } else {
                callback();
            }
        }
    },
    UniqueId: function () {
        return Math.random().toString(36).substr(2);
    },
    Clipboard: {
        Copy: function (text) {
            var node = document.createElement('input');
            document.body.appendChild(node);
            node.value = text;
            node.select();
            document.execCommand('copy');
            node.remove();
        }
    }
};

// Function to get current timestamp in microseconds
function currentTimestamp() {
    return new Date().getTime();
}

//class for use to simple counters
function Countdown(options) {
    var timer,
        instance = this,
        seconds = options.seconds || 10,
        updateStatus = options.onUpdateStatus || function () {},
        counterEnd = options.onCounterEnd || function () {};

    function decrementCounter() {
        updateStatus(seconds);
        if (seconds === 0) {
            counterEnd();
            instance.stop();
        }
        seconds--;
    }

    this.start = function () {
        clearInterval(timer);
        seconds = options.seconds;
        timer = setInterval(decrementCounter, 1000);
    };

    this.stop = function () {
        clearInterval(timer);
    };
}


// Init all needed references
$(document).ready(function() {
    /**
     * Function error handler
     **/
    $(document).ajaxError(function(jqXHR, error) {
        var message, header;

        if (!error.status) {
            return;
        }

        var statusErrorMap = {
            '400': __("Server understood the request but request content was invalid"),
            '401': __("Unauthorised access"),
            '403': __("Forbidden - resource can't be accessed"),
            '404': __("Page or file not found"),
            '500': __("Internal Server Error"),
            '503': __("Service Unavailable")
        };
        message = statusErrorMap[error.status];
        if (!message) {
            message = __("Unknown Error");
        }

        if (error.status === 401) {
            SJ.session_expired_counter_down = 5;
            message = __('Your session has expired! <br>You will be redirected to login page in ') + '<b><span id="session_expired_counter_down">' + SJ.session_expired_counter_down + '</span> sec. </b>';
            message = SJ.Core.print_box(message, {type: 'warning', header: __('Information')});
            header = 'Session Expired';

            SJ.session_expired_timeout = function() {
                $("#session_expired_counter_down").html(SJ.session_expired_counter_down);
                SJ.session_expired_counter_down = (SJ.session_expired_counter_down > 0) ? SJ.session_expired_counter_down - 1 : 0;
                if (SJ.session_expired_counter_down === 0) {
                    window.location.reload();
                } else {
                    setTimeout("SJ.session_expired_timeout()", 1000);
                }
            };
            setTimeout("SJ.session_expired_timeout()", 1);

        } else if (error.status === 403) {
            message = SJ.Core.print_box(message, {type: 'warning', header: __('Information')});
            header = __('Forbidden access');

        } else {
            message = SJ.Core.print_box(message, {type: 'danger', header: __('Error'), more: error.responseText});
            header = __('Error');
        }

        if ($('.pane.pane-loaded').length > 0) {
            $('.pane .pane-loaded-loading').remove();
            $('.pane .page-header').html('<h2>' + header + '</h2>');
            $('.pane .page-body').html(message);
        } else {
            message = '<div id="page-error" class="page-header"><h2>' + header + '</h2></div><div class="pane-content">' + message + '</div>';
            SJ.Pane.fill(message);
        }
    });

    // If using the ajax request then do this
    $(document).on('click', '.ajax-container a, .ajax-container input[type="submit"], .ajax-container button', function(event) {

        var ignore_classes = ['prevent-default', 'use-pane', 'just-link', 'close'],
            use_ajax = true;

        for (var i in ignore_classes) {
            if ($(this).hasClass(ignore_classes[i])) {
                use_ajax = false;
            }
        }

        // Ignore tinyMCE buttons
        if ($(this).parents('.mce-tinymce').length || $(this).parents('.mejs-container').length) {
            use_ajax = false;
        }

        // Ignore validation form
        var $form = $(this).parents('._validation-form');
        if ($form.length) {
            use_ajax = false;
            if (SJ.Core.Validation.check_form($form) === false) {
                event.stopImmediatePropagation();
                event.preventDefault();
                return false;
            }

        }


        if (use_ajax) {
            event.preventDefault(); // Only when we use ajax
            var href = '',
                method = '',
                data = '',
                back = '',
                id = Math.floor((Math.random() * 1000) + 1),
                $container = $(this).parents('.ajax-container').first();

            // If container have CompactEditor - first must save content to hidden textarea
            SJ.Core.CompactEditor.remove($container);
            SJ.Core.CompactEditor.remove($container, true); //inline

            if ($(this).is('button') || $(this).is('input[type="submit"]')) {
                href = $(this).parents('form').attr('action');
                method = 'POST';
                data = $(this).parents('form').serializeArray();
                data.push({name: $(this).attr('name'), value: $(this).val()});
            }

            if ($(this).is('a')) {
                href = $(this).attr('href');
                method = 'GET';
            }

            back = SJ.Core.getURLParameter('back', href);

            $container.attr('id', id);
            $container.prepend('<div class="ajax-container-loading"><i class="fa fa-spinner fa-spin"></i></div>');

            $.ajax({
                url: href,
                data: data,
                type: method,
                cache: false, // In issue IE8 Bug #11231
                success: function(data) {
                    $container.html(data);

                    if ( SJ.Core.PaneVisible() ) {

                        SJ.Pane.Load.run_queue();

                    } else {

                        SJ.Core.CompactEditor.init();
                        SJ.Core.CompactEditor.init(true);
                        SJ.CMSFrontend.Elements.init();
                    }

                },
                complete: function() {
                    $container.find('.ajax-container-loading').remove();

                    if (back.length) {
                        if ( SJ.Core.PaneVisible() ) {
                            var backButton = $('.pane .page-header .sj-pane-back, .ajax-container-back');
                            if ( ! backButton.length) {
                                $('.pane .page-header').prepend('<a class="sj-pane-back ajax-container-back" data-id-container="' + id + '" href="' + back + '"><i class="icon-back-arrow"></i></a>');
                            } else {
                                if (typeof backButton.data('id-container') !== 'undefined') {
                                    $('.pane .page-header .sj-pane-back').data('id-container', $container.attr('id'));
                                }
                            }
                        } else {
                            $container.find('h1, h2, h3, h4, h5').first().prepend('<a class="ajax-container-back" href="' + back + '"><i class="fa fa-reply-all"></i></a> ');
                        }
                    } else {
                        if ( SJ.Core.PaneVisible() ) {
                            $('.pane .page-header .sj-pane-back').remove();
                        } else {
                            $container.find('.ajax-container-back').remove();
                        }

                    }
                }
            });

        }
    });

    $(document).on('click', 'a.ajax-container-back', function(event) {
        event.preventDefault();

        var href = $(this).attr('href');

        if ( SJ.Core.PaneVisible() ) {
            $(this).remove();
        }

        $('.pane .page-body .ajax-container').append('<a id="link-to-refresh" href="' + href + '"></a>');
        $('#link-to-refresh').trigger('click');
    });

    $(document).on('click', '.sj2-form-upload-input', function() {
        $(this).parent().find('.sj2-form-upload-target').trigger('click');
    });

    $(document).on('click','.sj-clear-input',function() {
        var clean = $(this).data('sj-cleanfields');

        if ( clean !== undefined ) {
            var fieldsToClean = clean.split(',');

            fieldsToClean.forEach(function(name) {
                var trimmed_name = name.trim();
                $("[name='" +  trimmed_name + "']").val('');
            });
        } else {
            throw new Error('Fields to clean are not set.');
        }
    });

    $(document).on('click','.sj-icon-toggle',function(){
        var icon = $(this).find('i');
        var self = $(this);

        var address = '';
        var endpoint_name = $(this).data('address');
        var id = $(this).data('id');
        var value = $(this).data('value');

        if (endpoint_name !== '' && endpoint_name !== undefined && id !== '' && id !== undefined && value !== '' && value !== undefined) {
            value ^= 1;
            address = endpoint_name + '/toggle?id=' + id + '&on=' + value;

            $.ajax({
                    method: "GET",
                    url: address
                })
                .done(function (response) {
                    if (response == 1) {
                        $(icon).toggleClass('fa-check fa-ban');
                        self.data('value', value);
                    }
                });
        }
        else {
            throw new Error('Set all options.');
        }
    });

    //Detect wheel mouse click and ignore when click on use-pane class
    $(document).on('click', function(event) {
        switch(event.which)
        {
            case 1:
                //left Click
                break;
            case 2:
                //middle Click
                if($(event.target).hasClass('use-pane')){
                    event.preventDefault();
                }
                break;
            case 3:
                //right Click
                break;
        }
    });


    $(document).on('click', 'a.ajax-container-refresh', function(event) {
        event.preventDefault();

        var id = $(this).data('id-container'),
            href = $(this).attr('href');

        $('#' + id).append('<a id="link-to-refresh" href="' + href + '"></a>');
        $('#link-to-refresh').trigger('click');
    });

    // Button shortcuts
    $(document).on('click', 'button[data-button-shortcut]', function(event) {
        var shortcut = $(event.target).attr('data-button-shortcut');
        var scope;
        if ($(event.target).attr('data-button-shortcut-scope')) {
            scope = $(event.target).attr('data-button-shortcut-scope');
        } else {
            scope = 'body';
        }
        $(scope).find('button[name="'+shortcut+'"]').click();
    });

    $(document).on('click', '.edit_event_local', function() {
        var uri = $(this).attr('data-link');
        var onClick = window.open(uri, '_blank', "location=yes,height=570,width=820,scrollbars=yes,status=yes,modal=yes");

        //SJ.Core.Calendar.syncEditInfo();

        var timer = setInterval(function() {
            if(onClick.closed) {
                clearInterval(timer);
                $('#sync_o365').trigger('click');
            }
        }, 1000);
    });

    if (jQuery().placeholder) {
        $(":input[placeholder]").placeholder();
    }

    // Remove class pending and hide when img not loaded (tinyMCE content)
    $('img.pending.hide, img.pending.bs3-hide').removeClass('pending hide bs3-hide');

    // Read user id from right top corner (profile)
    SJ.Core.loadUserId();

    // Init for pane
    if (typeof SJ.Pane !== 'undefined') {
        SJ.Pane.Load.add(SJ.Core.KeywordsList.init);
        SJ.Pane.Load.add(SJ.Core.SubjectsList.init);
        //SJ.Pane.Load.add(SJ.Core.CompactEditor.init);
        //SJ.Pane.Load.add(function() {SJ.Core.CompactEditor.init(true)}); //Inline mode
        SJ.Pane.Load.add(SJ.Core.Datepicker.init);
        SJ.Pane.Load.add(SJ.Core.LoadImages.init);
        SJ.Pane.Load.add(SJ.Core.Filters.init);
        SJ.Pane.Load.add(SJ.Core.Rating.init);
        SJ.Pane.Load.add(SJ.Core.InputList.init);
        SJ.Pane.Load.add(SJ.Core.Colorpicker.init);
        SJ.Pane.Load.add(SJ.Core.Selectpicker.init);
        SJ.Pane.Load.add(SJ.Core.Image.init);
    }
    //init for normal pages
    SJ.Core.KeywordsList.init();
    SJ.Core.SubjectsList.init();
    SJ.Core.CompactEditor.init();
    SJ.Core.CompactEditor.init(true); //Inline mode
    SJ.Core.Datepicker.init();
    SJ.Core.Validation.init();
    SJ.Core.LoadImages.init();
    SJ.Core.popover();
    SJ.Core.ShareView.init();
    SJ.Core.Form.init();
    SJ.Core.Filters.init();
    SJ.Core.Toggle.init();
    SJ.Core.Rating.init();
    SJ.Core.Popover.init();
    SJ.Core.InputList.init();
    SJ.Core.Colorpicker.init();
    SJ.Core.Selectpicker.init();
    SJ.Core.SessionManager.init();
    SJ.Core.SafetyButton.init();

    var keys     = [];
    var konami  = '38,38,40,40,37,39,37,39,66,65';

    $(document).keydown(function(e) {
        keys.push( e.keyCode );
        if (keys.toString().indexOf( konami ) >= 0 ) {
            // do something when the konami code is executed

            alert('Konami code detected');
            $('.sj-konami-hide-class').hide();
            $('.sj-konami-show-class').show();

            // empty the array containing the key sequence entered by the user
            keys = [];
        }
    });
});



// This loads when images have loaded - #24137 and #24231
$(window).on('load', function() {
    // Remove class pending and hide when img not loaded (tinyMCE content)
    $('img.pending.hide, img.pending.bs3-hide').removeClass('pending hide bs3-hide');

    WebFont.load({
        google: {
            families: [
                'Arimo:400,400i,700,700i',
                'Cousine:400,400i,700,700i',
                'Droid+Sans+Mono',
                'Glass+Antiqua',
                'Lato:400,400i,700,700i',
                'Oswald:400,700',
                'Tinos:400,400i,700,700i',
                'Unna:400,400i,700,700i',
                'VT323'
            ]
        }
    });
});

jQuery.fn.originalLoad = jQuery.fn.load;
jQuery.fn.load = function () {
    if ( arguments.length === 0 ) {
        return jQuery.fn.trigger.apply(this, ['load']);
    }

    if ( typeof arguments[0] === "function" && typeof arguments[0].nodeType !== "number" ) {
        return jQuery.fn.on.apply(this, ['load', arguments[0]]);
    }

    return jQuery.fn.originalLoad.apply(this, arguments);
};

jQuery.fn.originalOn = jQuery.fn.on;
jQuery.fn.on = function () {
    if ( typeof arguments[0] === 'string' && arguments[0].toLowerCase() === 'ready' ) {
        var croppedArgs = [];
        for (var i = 1; i < arguments.length; i++) {
            croppedArgs.push(arguments[i]);
        }
        return jQuery.fn.ready.apply(this, croppedArgs);
    }

    return jQuery.fn.originalOn.apply(this, arguments);
};
